<template>
  <div class="not-found-wrapper">
    <Background404 class="background" />
    <div class="content mt-10">
      <NotFoundSvg class="not-found-image" />
      <Svg404 class="svg404" />

      <span class="not-found__text m-subtitle-1 mt-15">Тут ничего нет... кажется, вы заблудились</span>
      <v-btn
          @click="goToMain"
          class="go-back-button mt-10" text >Вернутся на главную</v-btn>
    </div>
  </div>
</template>

<script>
import Svg404 from '@/assets/icons/svg/404.svg';
import NotFoundSvg from '@/assets/icons/svg/not-found.svg';
import Background404 from '@/assets/icons/svg/background-404.svg';

export default {
  name: "not-found",
  components: {
    Svg404,
    NotFoundSvg,
    Background404
  },
  methods:{
    goToMain(){
      this.$router.replace('/my-schedule');
    }
  }
}
</script>

<style scoped lang="scss">
.not-found-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 80vw;
  height: 80vw;
  z-index: 0;
  object-fit: cover;

}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.not-found-image,
.svg404 {
  max-width: 300px;
  margin: 1rem 0;
}

.not-found__text{
  color: var(--black);
}

.go-back-button{
  width: 280px;
  height: 42px;
  background-color: var(--accent-purple);
  font-family: Open Sans, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
  text-transform: none;
}
</style>